import { CustomClientModelVariable } from "@services/api/types";
import { getLastMediaVarId } from "./media_vars";

export interface CSVDataParsedError {
  code: string;
  message: string;
  type: string;
}

export interface CSVDataParsed {
  data: string[][];
  errors: CSVDataParsedError[];
  meta: string[];
}

export interface CSVToModelMediaValues {
  data: { [key: string]: { [key: string]: number } };
  mediaVars: CustomClientModelVariable[];
}

export interface CSVContentStatus {
  isHeaderValid: boolean;
  isModelVarsValid: boolean;
}

export const isCsvContentValid = (
  data: string[][],
  timePeriods: string[],
  mediaVars: CustomClientModelVariable[],
  modelHeader: string
): CSVContentStatus => {
  const headerRow = data[0].map((header) => header.trim().toLowerCase());
  const expectedHeaderValues = [
    ...timePeriods.map((timePeriod) => timePeriod.toLowerCase()),
    modelHeader
  ];
  const isHeaderValid = expectedHeaderValues
    .map((value) => headerRow.includes(value))
    .every((value) => value);

  const csvMediaVars = data
    .filter((_, idx) => idx !== 0)
    .map((row) => row[0].trim().toLowerCase());
  const expectedMediaVars = mediaVars.map((mediaVar) =>
    mediaVar.name.trim().toLowerCase()
  );
  const isMediaVarsValid = expectedMediaVars
    .map((value) => csvMediaVars.includes(value))
    .every((value) => value);

  return { isHeaderValid, isModelVarsValid: isMediaVarsValid };
};

export const csvToMediaValues = (
  data: string[][],
  mediaVars: CustomClientModelVariable[],
  color: string
): CSVToModelMediaValues => {
  const parsedData: { [key: string]: { [key: string]: number } } = {};

  const columnMapping: { [key: number]: string } = {};

  const modelMediaVars = [...mediaVars];

  const headerRow = data[0].filter((_, idx) => idx !== 0);

  headerRow.forEach((header, idx) => {
    const headerFmt = header.trim().toUpperCase();
    parsedData[headerFmt] = {};
    columnMapping[idx + 1] = headerFmt;
  });
  const rowsData = data.filter((_, idx) => idx !== 0);
  rowsData.forEach((row, idx) => {
    const colName = row[0].trim().toLowerCase();
    if (colName.length !== 0) {
      let mediaVar = mediaVars.find(
        (mediaVar) => mediaVar.name.toLowerCase() === colName
      );
      if (!mediaVar) {
        const lastIndex = getLastMediaVarId(modelMediaVars) + idx;
        mediaVar = {
          id: lastIndex + 1,
          name: colName,
          is_significant: false,
          order: lastIndex + 1,
          type: "media",
          color: color,
          input_type: "input",
          is_custom: true
        };
        modelMediaVars.push(mediaVar);
      }
      const mediaVarId = mediaVar.id;

      const rowData = row.filter((_, idx) => idx !== 0);
      rowData.forEach((value, idx) => {
        const headerRef = columnMapping[idx + 1];
        parsedData[headerRef][mediaVarId] = Math.max(Number(value), 0);
      });
    }
  });

  return { data: parsedData, mediaVars: modelMediaVars };
};
